<!-- 召回通知单列表 -->
<template>
    <div>
        <subComponents ref="showSelectData"></subComponents>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs v-if="tabForm" :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }"
                            @tabHeight="(val) => { mxHeight = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form class="baseForm" id="mainInfo" label-width="100px" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false" :inline-message="false">
                                        <el-row>
                                            
                                            <el-form-item label="终端公司" prop="tcmName" :rules="[{ required: true, message: '终端公司不能为空', trigger: ['blur', 'change'] }]">
                                                <label slot="label" :style="$common.labelStyle('终端公司')" v-html="$common.htmlLabel('终端公司')"></label>
                                                <!-- 检索终端公司 -->
                                                <el-tooltip class="item" :disabled="sendDataInfo.tcmName == null || sendDataInfo.tcmName == '' ? true : false || sendDataInfo.tcmName.length <= 9" effect="dark"
                                                            :content="sendDataInfo.tcmName" placement="bottom-start">
                                                    <el-input clearable v-model="sendDataInfo.tcmName" ref="tcmName" id="tcmName"
                                                              @keyup.enter.native="openSearch(938101838391, 0, 'tcmName', 'tcmName,tcmId', 'hospitalName')" :disabled="dataActionBox.actionType == 2">
                                                        <el-button @click="openSearch(938101838391, 0, 'tcmName', 'tcmName,tcmId', 'hospitalName')" slot="append" icon="el-icon-search"
                                                                   :disabled="dataActionBox.actionType == 2">
                                                        </el-button>
                                                    </el-input>
                                                </el-tooltip>
                                            </el-form-item>
                                            <el-form-item label="医院" prop="hospitalName" :rules="[{ required: true, message: '医院不能为空', trigger: ['blur', 'change'] }]">
                                                <label slot="label" :style="$common.labelStyle('医院')" v-html="$common.htmlLabel('医院')"></label>
                                                <!-- 检索医院 -->
                                                <el-tooltip class="item" :disabled="sendDataInfo.hospitalName == null || sendDataInfo.hospitalName == '' ? true : false || sendDataInfo.hospitalName.length <= 9" effect="dark"
                                                            :content="sendDataInfo.hospitalName" placement="bottom-start">
                                                    <el-input clearable v-model="sendDataInfo.hospitalName" ref="hospitalName" id="hospitalName"
                                                              @keyup.enter.native="openSearch(8193891732838791, 0, 'hospitalName', 'hospitalName,hospitalId', 'bgmName')" :disabled="dataActionBox.actionType == 2">
                                                        <el-button @click="openSearch(8193891732838791, 0, 'hospitalName', 'hospitalName,hospitalId', 'bgmName')" slot="append" icon="el-icon-search"
                                                                   :disabled="dataActionBox.actionType == 2">
                                                        </el-button>
                                                    </el-input>
                                                </el-tooltip>
                                            </el-form-item>
                                            <el-form-item label="商品名称" prop="bgmName" :rules="[{ required: true, message: '商品名称不能为空', trigger: ['blur', 'change'] }]">
                                                <label slot="label" :style="$common.labelStyle('商品名称')" v-html="$common.htmlLabel('商品名称')"></label>
                                                <!-- 检索商品名称 -->
                                                <el-tooltip class="item" :disabled="sendDataInfo.bgmName == null || sendDataInfo.bgmName == '' ? true : false || sendDataInfo.bgmName.length <= 9" effect="dark"
                                                            :content="sendDataInfo.bgmName" placement="bottom-start">
                                                    <el-input clearable v-model="sendDataInfo.bgmName" ref="bgmName" id="bgmName"
                                                              @keyup.enter.native="openSearch(853533363572736, 0, 'bgmName', 'bgmName,bgmId', 'psprice')" :disabled="dataActionBox.actionType == 2">
                                                        <el-button @click="openSearch(853533363572736, 0, 'bgmName', 'bgmName,bgmId', 'psprice')" slot="append" icon="el-icon-search"
                                                                   :disabled="dataActionBox.actionType == 2">
                                                        </el-button>
                                                    </el-input>
                                                </el-tooltip>
                                            </el-form-item>
                                            <el-form-item label="价格" prop="psprice" :rules="[{ required: true, message: '价格不能为空', trigger: ['blur', 'change'] }]">
                                                <label slot="label" :style="$common.labelStyle('价格')" v-html="$common.htmlLabel('价格')"></label>
                                                <el-input class="form_codition" type="text" ref="psprice" @keyup.enter.native="nextFocus(0, '')" v-model.trim="sendDataInfo.psprice"
                                                          :disabled="dataActionBox.actionType == 2"></el-input>
                                            </el-form-item>
                                        </el-row>
                                    </el-form>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :footFlag="false" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction"
                        @showPrintPlan="showPrintPlan"></v-foot>
            </div>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
    </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";
import NP from "number-precision";
export default {
    name: "terminalCompanypriceAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
    },
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                bgmId: "",
                bgmName: "",
                hospitalId: "",
                hospitalName: "",
                tcmId: "",
                tcmName: "",
                psprice: "",
            },
            showTabs: "",
            formDataList: [],
            DialogVisible: false,
            seTitle: "",
            seWidth: "",
            seId: "",
            seType: "",
            seIndex: "",
            sField: "", // 赋值字段
            fField: "", //焦点字段
            parentSearchData: {},
            mxHeight: 0,
            tabForm: [
                {
                    jciName: "",
                }
            ], // tab循环的主表单
            mxForm: [],
            footForm: [],
            requesUrl: "",
            token: {
                token: sessionStorage.getItem("token"),
            },
            inputel: [],
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        // 主表单select框切换enter切换焦点事件方法
        selectChange(e) {
            if (e == false) {
                for (let index = 0; index < this.inputel.length; index++) {
                    if (this.inputel[index] == document.activeElement) {
                        this.nextFocus(index);
                        break;
                    }
                }
            }
        },
        imgur() {
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
            this.imgUrl = this.$store.getters.getConfig.imgUrl;
        },
        showPrintPlan() {
            // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        changeInputModel(val) {
            this.DialogVisible = false;
            if (val && (val != "" || val != undefined)) {
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val, flag) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.$set(this.sendDataInfo, item, val[item])
            });
            this.$nextTick(() => {
                this.nextFocus(this.seIndex, this.fField);
            });
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField, fField) {
            this.parentSearchData = {}
            if (type == 'salesName') {
                if (this.sendDataInfo.cmId == '' || this.sendDataInfo.cmId == null) {
                    return this.$message.error("请先选择客户");
                }
                this.parentSearchData.unitId = this.sendDataInfo.cmId;
            }
            if (type == 'opmName') {
                this.parentSearchData.opmSalesperson = 1
                this.parentSearchData.opmBuyer = ""
            }
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            this.fField = fField;
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },


        initActionBox(sendDataInfo) {
            this.$confirm("确定取消新增吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$emit("drawerCancel", 0);
                    this.init();
                    this.$refs.sendDataInfo.resetFields();
                })
                .catch(() => {
                });
        },
        init() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }
        },
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            var oldData = this.actionData.oldData;
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key]);
                }
                this.sendDataInfo.rcnId = dataInfo.rcnId
            } else {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key]);
                }
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight();
                    } else {
                        this.mxHeight = this.$common.getHeight();
                    }
                    this.initFocus();
                }, 16.7);
            });
        },
        sendDataAction(sendDataInfo) {
            console.log(sendDataInfo);
            this.$refs.sendDataInfo.validate((valid) => {
                if (valid) {
                    this.sub();
                } else {
                    this.$message({
                        message: "请完善主表单必填信息",
                        type: "error",
                    });
                    return false;
                }
            });
        },
        async sub() {
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.terminalCompanyPriceadd(sendData);
            } else {
                var responseData = await this.$http.terminalCompanyPricemodify(sendData);
            }
            if (responseData.status == 200) {
                this.init();
                this.$message.success("操作成功");
                this.$emit("drawerCancel", 1);
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        getValue(val, type, fieldType, arr) {
            var str = ""
            if (type == 'bgiType' || fieldType == 'formatter') {
                if (arr) {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && item.value == val) {
                            str = item.key
                        } else if (String(Number(item.key)) != NaN && item.key == val) {
                            str = item.value
                        }
                    })
                }
            } else {
                str = val || ""
            }
            return String(str)
        },
        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == "") {
                    this.inputel[index].focus();
                    break;
                }
            }
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById("mainInfo");
            if (el) this.inputel = el.getElementsByTagName("input");
        },
        // 输入框切换焦点
        nextFocus(index, fField) {
            if (fField == "keydown") {
                return;
            }
            var aindex = index + 1;
            if (
                this.inputel[aindex].value != "" ||
                this.inputel[aindex].disabled
            ) {
                this.nextFocus(aindex);
                return;
            }
            this.$nextTick(() => {
                this.inputel[aindex].focus();
            });
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.imgur();
        this.$nextTick(() => {
            this.openBox();

        });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput();
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
    margin-bottom: 0;
}
</style>